import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import CSSModules from 'react-css-modules'
import generalActions from 'redux/actions/generalActions'
import pollActions from 'redux/actions/pollActions'
import Modalizer from 'components/modalizer/modalizer'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import { localize } from 'helpers/translator'
import pollSelectors from 'redux/selectors/poll'
import Settings from 'components/settings/settings'

import styles from './poll_edit_settings_modal.scss'

class PollEditSettingsModal extends PureComponent {
	constructor() {
		super()

		this.closeModal = this.closeModal.bind(this)
	}

	closeModal() {
		this.props.actions.closeModal(this.props.modalName)
	}

	render() {
		return (
			<Modalizer width='570px' height='565px' nopadding={true} closeAction={this.closeModal}>
				<div styleName='wrapper'>
					<Settings
						settings={this.props.settings}
						saveSettings={this.props.actions.savePollSettings}
						cancelSettings={this.closeModal}
						title = {localize('poll_edit_settings_modal_title')}
					/>
				</div>
			</Modalizer>
		)
	}
}

PollEditSettingsModal.propTypes = {
	modalName: PropTypes.string,
}

function mapStateToProps(state) {
	return pollSelectors.editSettingsSelector(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeModal: generalActions.closeModal,
		savePollSettings: pollActions.savePollSettings,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(PollEditSettingsModal, styles, {allowMultiple: true}))
